// Espelho de AiFailureMessages (servidor): a resposta que o assistente dá quando a IA falha NÃO é um treino e nunca se oferece para guardar como plano.
// Curta e a falar do serviço de IA indisponível; uma resposta longa que apenas menciona "indisponível" é conteúdo.
export const isAiFailure = (text) => {
  if (typeof text !== 'string' || !text.trim()) return true;
  const t = text.trim();
  if (t.length >= 200) return false;
  return /indispon/i.test(t) && /servi[çc]o de IA/i.test(t);
};
